import { Link } from "react-router-dom";
import { Mail, Instagram, Facebook } from "lucide-react";
import { OFFICE, LAWYERS } from "../../data/content";

const Footer = () => {
  return (
    <footer className="rr-footer" data-testid="site-footer">
      <div className="rr-container">
        <div className="rr-footer-grid">
          <div style={{ maxWidth: 320 }}>
            <h6 className="font-display" style={{ fontSize: 20 }}>
              Rendón Ramos
            </h6>
            <p style={{ marginTop: 8 }}>
              Inmobiliaria y Despacho Jurídico. Operaciones inmobiliarias con certeza legal y
              defensa jurídica profesional en Técpan de Galeana, Guerrero.
            </p>
          </div>
          <div>
            <h6>Contacto</h6>
            <p style={{ marginTop: 8 }}>
              Oficina: <a href={OFFICE.phoneTel}>{OFFICE.phoneDisplay}</a>
              <br />
              {OFFICE.hours}
            </p>
          </div>
          <div>
            <h6>Abogados</h6>
            <p style={{ marginTop: 8 }}>
              {LAWYERS.map((l) => (
                <span key={l.id}>
                  {l.name}
                  <br />
                </span>
              ))}
            </p>
          </div>
        </div>

        {/* ── Copyright row ── */}
        <div className="rr-footer-bottom">
          <span>
            © {new Date().getFullYear()} Inmobiliaria y Despacho Jurídico Rendón Ramos.
            Todos los derechos reservados.
          </span>
          <Link to="/admin" className="admin-link" data-testid="footer-admin-link">
            Administración
          </Link>
        </div>
      </div>

      {/* ── The Web Citizens credit band ── */}
      <div className="twc-band" data-testid="twc-band">
        <div className="rr-container twc-inner">
          <span className="twc-label">Sitio creado por</span>
          <a
            href="https://instagram.com/thewebcitizens"
            target="_blank"
            rel="noopener noreferrer"
            className="twc-brand"
            aria-label="The Web Citizens"
          >
            <img src="/assets/twc-logo.jpg" alt="The Web Citizens" className="twc-logo" />
            <span className="twc-name">TheWebCitizens</span>
          </a>
          <div className="twc-links">
            <a
              href="https://instagram.com/thewebcitizens"
              target="_blank"
              rel="noopener noreferrer"
              className="twc-link"
              aria-label="Instagram @thewebcitizens"
            >
              <Instagram size={15} />
              @thewebcitizens
            </a>
            <a
              href="https://facebook.com/thewebcitizens"
              target="_blank"
              rel="noopener noreferrer"
              className="twc-link"
              aria-label="Facebook @thewebcitizens"
            >
              <Facebook size={15} />
              @thewebcitizens
            </a>
            <a
              href="mailto:thewebcitizens@gmail.com"
              className="twc-link"
              aria-label="Email thewebcitizens@gmail.com"
            >
              <Mail size={15} />
              thewebcitizens@gmail.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
